import { BillingMode } from '../../../../services/exports/Constants';

export default {
  billing_modes: {
    [BillingMode.Stripe]: 'Método de pagamento',
    [BillingMode.InternalInvoicing]: 'Pagamentos',
  },
};
